module.exports = __webpack_public_path__ + "img/popup13.d2805068.png";